<template>
  <div class="dflexc-jcs merchant-list-panel">
    <div class="merchant-list-header">Merchant List</div>

    <ul class="merchant-list">
      <li v-for="(m, idx) in mp.list[mp_idx].merchants"
          :key="idx" class="merchant-list-item"
          :class="{'even': idx % 2 === 0, 'merchant-li-selected': _merch_selected(idx)}"
          @click="$emit('merch_select', idx)">
        <div class="dflexc-jcs">
          <div class="dflexr-jcsb">
            <div class="merch-race">
              {{ _race(m.race) }}
            </div>
            <div class="merch-el" v-if="m.stats.el > 3">
              <span class="el-txt">EL:</span> {{ m.stats.el }}
            </div>
          </div>
          <div class="merch-type" :class="{ 'merch-selected': _merch_selected(idx) }">
            {{ _type(m.type) }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/colors.scss";

.merchant-list-panel {
  border-right: 1px solid white;
  padding-right: 1rem;
  height: 100%;
  .merchant-list-header {
    margin-top: .5rem;
  }
  .txt-race-type {
    font-size: .8rem;
    color: $bg-drk20;
    background-color: rgba(56, 168, 153, 0.1);
  }

  ul.merchant-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    background-color: $bg-drk10;
    width: 150px;

    .merchant-li-selected {
      position: relative;
      border: 1px solid cyan;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      &:before {
        content: '';
        position: absolute;
        top: -1px;
        left:-.5rem;
        width: .5rem;
        height: calc(100% + 2px);
        background-color: cyan;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }

    .merch-el {
      font-size: .8em;
      margin-right: .5rem;
    }

    .el-txt {
      font-size: .5em;
      vertical-align: top;
    }

    .merch-race {
      font-size: .5em;
      color: chartreuse;
      text-align: left;
      padding-left: .5rem;
    }

    .merch-type {
      color: #699ebf;
    }

    .merch-selected {
      font-weight: bold;
      color: yellow;
    }

    li {
      padding: 0.3rem 0;
      margin: 2px 0;

      &:hover {
        background-color: rgba(0, 255, 208, 0.15);
      }
    }

    .even {
      padding:.3rem 0;
      background-color: $bg-drk20;
    }
  }
}


</style>

<script setup>

import {inject} from "vue";

const props = defineProps(['mp_idx'])
const mp = inject('mp_pkg')

const xRace = ['Man', 'Dwarf', 'Elf']
const yRace = ['Me', 'Dw', 'Ef']

const xType = ['Al','Eq', 'Ht', 'Jw', 'Mg', 'Mc', 'Sg', 'Sl']
const yType = ['Alchemist', 'Equipment', 'Horse Trader', 'Jeweler',
  'Mage', 'Money Changer', 'Sage', 'Slaver']

const _race = (race) => {
  const idx = yRace.indexOf(race)
  return xRace[idx]
}

const _type = (type) => {
  const idx = xType.indexOf(type)
  return yType[idx]
}

const _merch_selected = (sIdx) => {
  const y = mp.active_merchant_idx[mp.active_mp]

  return y === sIdx
}

</script>
